/**
 * Global "Stay Awake" mode utility.
 *
 * When the admin enables "Stay Awake" mode:
 *   1. A Screen Wake Lock is held so the display never turns off.
 *   2. The inactivity auto-logout timer is suppressed.
 *
 * State is persisted in localStorage so it survives page reloads and is
 * visible to every tab.  A BroadcastChannel keeps all open tabs in sync
 * when the toggle is flipped.
 */

const STAY_AWAKE_KEY = "stayAwakeMode";
export const STAY_AWAKE_CHANNEL = "stay_awake_mode";

// ---------------------------------------------------------------------------
//  Read / write helpers
// ---------------------------------------------------------------------------

/** Check whether stay-awake mode is enabled (reads localStorage). */
export function isStayAwakeActive(): boolean {
  return localStorage.getItem(STAY_AWAKE_KEY) === "true";
}

/** Enable or disable stay-awake mode in localStorage. */
export function setStayAwakeMode(enabled: boolean): void {
  if (enabled) {
    localStorage.setItem(STAY_AWAKE_KEY, "true");
  } else {
    localStorage.removeItem(STAY_AWAKE_KEY);
  }
}

/** Clear stay-awake mode (e.g. on logout). */
export function clearStayAwakeMode(): void {
  localStorage.removeItem(STAY_AWAKE_KEY);
}
